import React, { useState } from 'react';

function AnalyzerForm({ onSubmit, isAnalyzing }) {
  const [url, setUrl] = useState('');
  const [testMode, setTestMode] = useState(false);
  const [useSemrush, setUseSemrush] = useState(true); // Default to true for SEMrush analysis
  const [useLighthouse, setUseLighthouse] = useState(true); // Default to true for Lighthouse analysis
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (url && typeof onSubmit === 'function') {
      // Pass all options to the onSubmit handler
      onSubmit(url, testMode, useSemrush, useLighthouse);
    } else {
      console.error('onSubmit is not a function or URL is missing');
    }
  };
  
  return (
    <div className="analyzer-form">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="url-input">Website URL</label>
          <input
            id="url-input"
            type="text"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="Enter website URL (e.g., example.com)"
            disabled={isAnalyzing}
            required
          />
        </div>
        
        <div className="form-options">
          <div className="checkbox-group">
            <input
              id="test-mode"
              type="checkbox"
              checked={testMode}
              onChange={(e) => setTestMode(e.target.checked)}
              disabled={isAnalyzing}
            />
            <label htmlFor="test-mode">Test Mode</label>
          </div>
          
          <div className="checkbox-group">
            <input
              id="use-semrush"
              type="checkbox"
              checked={useSemrush}
              onChange={(e) => setUseSemrush(e.target.checked)}
              disabled={isAnalyzing}
            />
            <label htmlFor="use-semrush">Include SEMrush Analysis (API Usage)</label>
            <div className="option-description">
              <small>This option uses the SEMrush API to collect domain data. Uncheck to save API usage.</small>
            </div>
          </div>
          
          <div className="checkbox-group">
            <input
              id="use-lighthouse"
              type="checkbox"
              checked={useLighthouse}
              onChange={(e) => setUseLighthouse(e.target.checked)}
              disabled={isAnalyzing}
            />
            <label htmlFor="use-lighthouse">Use Lighthouse</label>
            <div className="option-description">
              <small>This option uses Lighthouse to analyze performance metrics. Uncheck to save API usage.</small>
            </div>
          </div>
        </div>
        
        <button type="submit" className="submit-button" disabled={isAnalyzing || !url}>
          {isAnalyzing ? 'Analyzing...' : 'Analyze Website'}
        </button>
      </form>
      
      <style>{`
        .form-options {
          margin: 15px 0;
        }
        .checkbox-group {
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        }
        .checkbox-group input {
          margin-right: 8px;
        }
        .option-description {
          width: 100%;
          margin-left: 24px;
          color: #666;
        }
      `}</style>
    </div>
  );
}

export default AnalyzerForm;
